import { useConcatenateFilterSelection } from '../../../../components/filters/hooks/common.hook';
import { useFilterVariableGroupSelection } from '../../../../components/filters/hooks/report-filter-selection.hook';
import { useEncodeFilters } from '../../../../components/filters/hooks/use-encode-filters.hook';
import {
  useFilterCoefficientSelection,
  useFilterDrilltroughSelection,
  useFilterVariableCompBrandSelection,
} from '../../../../components/filters/hooks/use-filter-drillthrough-selection.hook';
import { useFilterPanelSelection } from '../../../../components/filters/hooks/use-filter-panel-selection.hook';
import { FilterEncoderComponentProps } from '../../../../components/filters/interfaces/filterable-component-props.interface';
/**
 * This component is responsible for gathering filter selections and then update the URL with them.
 */
export const DecompPageFilterProvider = ({
  children,
  trackRecentVisits = true,
}: FilterEncoderComponentProps) => {
  const filterSelection = useConcatenateFilterSelection(
    useFilterPanelSelection(), // Global filters
    useFilterDrilltroughSelection(), // Drill through/ Decomp model filters
    useFilterCoefficientSelection(), // Coefficient/Variriable selection
    useFilterVariableGroupSelection(), // Waterfall Type
    useFilterVariableCompBrandSelection(), // A combination of Waterfall name and comp brand
  );
  // Updates URL with encoded filters.
  useEncodeFilters(filterSelection, trackRecentVisits);
  return <>{children}</>;
};
